import {Dispatch} from 'redux';
import {ErrorDto, getErrorDtoFromApiError} from '../../../models/dtos/error.dto';
import {PAYMENT_REQUEST_FAIL, PAYMENT_REQUEST_RESET, PAYMENT_REQUEST_START, PAYMENT_REQUEST_SUCCESS} from './constants';
import {paymentRequestRequest} from './repository';
import {
  PaymentRequestFailAction,
  PaymentRequestResetAction,
  PaymentRequestStartAction,
  PaymentRequestSuccessAction
} from './types';

const paymentRequestStartAction = (): PaymentRequestStartAction => {
  return {
    type: PAYMENT_REQUEST_START,
  };
};
const paymentRequestSuccessAction = (payload: boolean): PaymentRequestSuccessAction => {
  return {
    type: PAYMENT_REQUEST_SUCCESS,
    payload: payload,
  };
};
const paymentRequestFailAction = (error: ErrorDto): PaymentRequestFailAction => {
  return {
    type: PAYMENT_REQUEST_FAIL,
    error: error,
  };
};
const paymentRequestResetAction = (): PaymentRequestResetAction => {
  return {
    type: PAYMENT_REQUEST_RESET,
  };
};

export const paymentRequest = () => async (dispatch: Dispatch) => {
  try {
    dispatch(paymentRequestStartAction());
    await paymentRequestRequest();
    dispatch(paymentRequestSuccessAction(true));
  } catch (error) {
    dispatch(paymentRequestFailAction(getErrorDtoFromApiError(error)));
  }
};

export const paymentRequestReset = () => (dispatch: Dispatch) => {
  dispatch(paymentRequestResetAction());
};
